import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import UserFilter from './UI.UserFilter';
import SetupDepartment from './UI.SetupDepartment';
import Edit from './UI.Edit';
import UIBatchCreateUser from './UI.Create.User.Batch';
import { AdvancedSearch, KtsForm } from 'kts-components';
import Message from 'kts-scaffold-framework/component/Message';
import {
    Form,
    Input,
    Icon,
    Button,
    message
} from 'antd';
import { truncate } from 'lodash';

const css = require('./index.scss');
const FormItem = Form.Item;

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    searchFormSubmit = (values) => {
        console.log(values);
        ModulesAction.updateSearchOptions(values);
        const options = Object.assign({}, values, this.modulesState.filterOptions, this.modulesState.userListPageMeta);
        ModulesAction.getUserQuery(options);
    }
    extendButton = () => {
        const disabledButton = this.modulesState.selectedUsers.length === 0;
        return (
            <div className={css.btnBox}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <Button onClick={this.editContariner} shape="round" size="small" icon="plus" className={css.antdBtn}>
                        新增用户
                    </Button>
                    <Button onClick={this.batchCreateUser} shape='round' size='small' className={!disabledButton ? css.antdBtnDesible : css.antdBtn}>
                        批量新增
                    </Button>
                    <Button onClick={this.setupDepartmentContariner} type="primary" shape='round' size='small' className={css.antdBtnGhost}>
                        设置部门
                    </Button>
                </div>
            </div>
        );
    }
    render() {
        return (
            
            <div className={css.headerWarpper}>
                <div className={css.headFilter} style={{alignItems:'center'}}>
                    <div style={{ display: 'flex', alignItems: 'flex-end',marginTop:10}}>
                        <AdvancedSearch
                            tableKey="tab1"
                            pre_data={[
                                {
                                    templateName: '正常用户',
                                    data: {
                                        userStatus: "1",
                                        userType: 'COMMON_USER',
                                    },
                                },
                            ]}
                            width={480}
                            height={44}
                            compact={true}
                            resetBtnClassName={css.antdBtnGhost}
                            defaultKey="userInfo"
                            placeholder="输入姓名/邮箱/手机号码"
                            searchFormSubmit={this.searchFormSubmit}
                        >
                            <KtsForm
                                labelCol={9}
                                wrapperCol={15}
                                labelAlign='left'
                                compact={true}
                                schema={{
                                    type: "object",
                                    properties: {
                                        userInfo: {
                                            type: "string",
                                            title: "输入姓名/邮箱/手机号码",
                                        },
                                        departmentId: {
                                            type: "string",
                                            title: "所属部门",
                                            enum: this.modulesState.departmentQuery
                                        },
                                        userStatus: {
                                            type: "radio",
                                            title: "用户状态",
                                            enum: [{
                                                "label": "已启用",
                                                "value": '1'
                                            }, {
                                                "label": "已禁用",
                                                "value": '0'
                                            }, {
                                                "label": "已邀请",
                                                "value": '2'
                                            }],
                                        },
                                        userType: {
                                            type: "radio",
                                            title: "用户角色",
                                            enum: [{
                                                "label": "普通用户",
                                                "value": 'COMMON_USER'
                                            }, {
                                                "label": "公司管理员",
                                                "value": 'COMPANY_ADMIN'
                                            }],
                                        },
                                        isContactor: {
                                            type: "radio",
                                            title: "是否为联系人",
                                            enum: [{
                                                "label": "是",
                                                "value": 'true'
                                            }, {
                                                "label": "否",
                                                "value": 'false'
                                            }]
                                        },
                                    }
                                }}
                            >
                            </KtsForm>
                        </AdvancedSearch>
                    </div>
                    <div className={`${css.prompt} ${css.btnBox}`} >
                        {this.extendButton()}
                    </div>

                </div>
            </div>

        );
    }


    private setupDepartmentContariner = () => {
        console.log(this.modulesState.selectedUsers);
        if (this.modulesState.selectedUsers.length === 0) {
            Message.warning('未选择任何用户，请重新选择');
        } else {
            MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
                Components: <SetupDepartment />,
                title: '设置部门'
            });
        }
    }

    private editContariner = () => {
        ModulesAction.updateDescriptionMsg('');
        ModulesAction.updateIsInnerUserControl(true);
        ModulesAction.updateRefreshEdit(true);
        ModulesAction.updateIsContactorIvew(false);
        this.modulesState.selectedJob = [];
        this.setModulesState(this.modulesState);
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <Edit />,
            title: '新增用户'
        });
    }
    private batchCreateUser = () => {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <UIBatchCreateUser />,
            title: '批量新增'
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/UserManage/UI.Search.tsx